import React from 'react'
import Layout from '../components/layout'
import Meta from '../components/meta'
import Hero3 from '../components/hero3'
import BannerButton from '../components/home/banner-button'
import ExploreTwoTile from '../components/home/explore-two-tile'
import ExploreBanner from '../components/home/explore-banner'
import ExploreThreeTile from '../components/home/explore-three-tile'
import Blog from '../components/home/blog'
import SearchBanner from '../components/home/search-banner'
import AchievementsCarousel from '../components/home/achievements-carousel'

const IndexPage = () => {
	return (
		<Layout>
			<Meta
				title="Maytronics Dolphin | Robotic Swimming Pool Cleaners Australia"
				description="Discover the smartest Maytronics robotic pool cleaners and products yet. Our robotic pool cleaners do the hard work. Book a demo today."
				keywords={[`maytronics`, `maytronics australia`, `home`]}
				lang="en-AU"
			>
				<link rel="canonical" href="https://www.maytronics.com.au/" />
				<link
					rel="alternate"
					href="https://www.maytronics.com/es-es/"
					hrefLang="es-ES"
				/>
				<link
					rel="alternate"
					href="https://www.maytronics.com/it-it/"
					hrefLang="it-IT"
				/>
				<link
					rel="alternate"
					href="https://www.maytronics.com/he-il/"
					hrefLang="he-IL"
				/>
				<link
					rel="alternate"
					hrefLang="en-US"
					href="https://www.maytronics.com/en-us/"
				/>
				<link
					rel="alternate"
					hrefLang="en-CA"
					href="https://www.maytronics.com/en-ca/"
				/>
				<link
					rel="alternate"
					href="https://www.maytronics.com/de-de/"
					hrefLang="de-DE"
				/>
				<link
					rel="alternate"
					href="https://www.maytronics.com/de-de/"
					hrefLang="de-AT"
				/>
				<link
					rel="alternate"
					href="https://www.robot-dolphin.fr/"
					hrefLang="fr-FR"
				/>
				<link
					rel="alternate"
					href="https://www.maytronics.com.au/"
					hrefLang="en-AU"
				/>
				<link
					rel="alternate"
					href="https://www.maytronics.com/global/"
					hrefLang="x-default"
				/>

				<link
					rel="preload"
					href="https://images.ctfassets.net/ftcnv5up9dxv/xMuFcLZyO2OQnihlJYCQD/5169944aa34214aa74e45b711573f233/BrandImage_HR_Dolphin_M600_CleaningWaterline_01_WithLogo.jpg?w=700&q=80&fit=fill&f=left"
					as="image"
				/>
			</Meta>
			<Hero3 locale="en-AU" />
			<div class="mx-auto w-11/12 max-w-7xl my-10 space-y-16">
				<BannerButton locale="en-AU" />
				<ExploreTwoTile locale="en-AU" />
				<ExploreBanner locale="en-AU" />
				<ExploreThreeTile locale="en-AU" />
				<AchievementsCarousel locale="en-AU" />
				<Blog locale="en-AU" />
				<SearchBanner locale="en-AU" />
			</div>
			
			
		</Layout>
	)
}

export default IndexPage
